<div class="content-scroll-top" [class.contraste]="this.contrasteAtivo" [class.visible]="this.showBtnScrollTop" [class.hidden]="!this.showBtnScrollTop">
    <button class="btn-scrollTop" (click)="scrollTop()">
    <span class="icon-span top-icon">
      <i class="fas fa-chevron-up"></i>
    </span>
  </button>
</div>